import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// Tối ưu constants và typing
const BANNER_IMAGES: any = {
  aion: {
    en: require("@/assets/events/aion/en.webp"),
    es: require("@/assets/events/aion/es.webp"),
    id: require("@/assets/events/aion/id.webp"),
    pt: require("@/assets/events/aion/pt.webp"),
    th: require("@/assets/events/aion/th.webp"),
  },
  openChest: {
    en: require("@/assets/events/SwipePad/en.webp"),
    es: require("@/assets/events/SwipePad/es.webp"),
    id: require("@/assets/events/SwipePad/id.webp"),
    pt: require("@/assets/events/SwipePad/pt.webp"),
    th: require("@/assets/events/SwipePad/th.webp"),
  },
} as const;

const EXTERNAL_LINKS = {
  OPEN_CHEST:
    "https://world.org/mini-app?app_id=app_c94a4a7ad759a10d4301469a06c8803d",
  AION: "https://world.org/mini-app?app_id=app_cb736f87fc78c84c31201f140bcfb5c0&path=/trading-competition",
} as const;

export const BannerReward = () => {
  const { i18n } = useTranslation();

  const bannerType = useMemo(() => Math.floor(Math.random() * 2), []);

  const { openChest, aion } = useMemo(() => {
    const lang = i18n.language as string;
    return {
      openChest: BANNER_IMAGES.openChest[lang] || BANNER_IMAGES.openChest.en,
      aion: BANNER_IMAGES.aion[lang] || BANNER_IMAGES.aion.en,
    };
  }, [i18n.language]);

  const linkClassName = "relative  w-full";
  const imgClassName = "h-full w-full";

  switch (bannerType) {
    case 1:
      return (
        <Link
          to={EXTERNAL_LINKS.OPEN_CHEST}
          className={linkClassName}
          data-category="Redirect"
          data-label="Popup"
          data-action="redirect_swipe_pad"
          target="_blank"
        >
          <img
            src={openChest}
            alt="open chest"
            className={`${imgClassName} !h-[140px]`}
            loading="lazy"
          />
        </Link>
      );

    default:
      return (
        <Link
          to={EXTERNAL_LINKS.AION}
          className={linkClassName}
          data-category="Redirect"
          data-label="Popup"
          data-action="redirect_aion"
          target="_blank"
        >
          <img
            src={aion}
            alt="aion"
            className={`${imgClassName}`}
            loading="lazy"
          />
        </Link>
      );
  }
};
